import Dropdown from '@/compoments/common/Dropdown'
import DropdownList from '@/compoments/DropdownList'
import { DispatherCustomerHistory } from '@/types/dispatcher/dashboard.types'
import DotsSvg from '@/assets/img/dots.svg'
import React from 'react'
import { format } from 'date-fns'
import UserPart from '@/compoments/common/UserPart'
import RatingWidthIcon from '@/compoments/common/RatingWidthIcon'

const HistoryTab = ({ data }: { data?: DispatherCustomerHistory }) => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Service</th>
                    <th style={{ width: 250 }}>Address</th>
                    <th>Technician</th>
                    <th>Rate</th>
                    <th style={{ width: 10 }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {data && data.orders.length > 0 ? (
                    data.orders.map((order, index) => (
                        <tr key={index}>
                            <td>
                                <span className="text-color-1">
                                    {' '}
                                    {format(order.startTime, 'MMM dd, yyyy')}
                                </span>
                            </td>
                            <td>{order.service.name}</td>
                            <td>
                                <span className="text--12 text-color-1 text-wrap">
                                    {`${order.address.street}, ${order.address.city}, ${order.address.state} ${order.address.postalCode}, ${order.address.country}`}
                                </span>
                            </td>
                            <td>
                                <UserPart
                                    name={order.technician.fullName}
                                    src={order.technician.photo}
                                />
                            </td>
                            <td>
                                <RatingWidthIcon
                                    rating={order?.feedback?.rating}
                                />
                            </td>
                            <td className="text-right sticky-end">
                                <Dropdown
                                    closeSelf={true}
                                    dropdownClasses="flex flex-col"
                                    button={
                                        <span className="ico">
                                            <img src={DotsSvg} alt="" />
                                        </span>
                                    }
                                    menuClassName="dropdown-md"
                                    menu={<DropdownList list={[]} />}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={5}>
                            <h4 className="text-center">History not found</h4>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export default HistoryTab
